(function () {
  'use strict';

  angular.module('app').component('bookingItemListServiceDate', bookingItemListServiceDate());

  function bookingItemListServiceDate() {
    return {
      bindings: {
        booking: '<',
      },
      controller: BookingItemListServiceDateComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/components/' +
        'booking-item-list-service-date/booking-item-list-service-date.component.html',
    };
  }

  BookingItemListServiceDateComponent.$inject = ['CONFIGURATIONS'];

  function BookingItemListServiceDateComponent(config) {
    const vm = this;

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.hourDisplay = config.HOUR_DISPLAY;
  }
})();
